// @flow

import * as React from 'react';
import {defineMessage, MessageDescriptor} from 'react-intl';
import Box from 'sail/Box';
import {BodyAlt, BodyMono} from 'sail/Text';
import {ButtonLink} from 'sail/Button';
import {useGuide} from '../../data/GuideProvider';
import {FormattedMessageOrString} from '../../../../data/localization/intlUtils';

const cards = [
  {
    label: {
      message: defineMessage({
        id: 'docsShell.integrationBuilder.test-cards.success',
        defaultMessage: 'Payment succeeds',
      }),
    },
    number: '4242 4242 4242 4242',
  },
  {
    label: {
      message: defineMessage({
        id: 'docsShell.integrationBuilder.test-cards.auth',
        defaultMessage: 'Payment requires authentication',
      }),
    },
    number: '4000 0025 0000 3155',
  },
  {
    label: {
      message: defineMessage({
        id: 'docsShell.integrationBuilder.test-cards.decline',
        defaultMessage: 'Payment is declined',
      }),
    },
    number: '4000 0000 0000 9995',
  },
];

const terminalCards = [
  {
    label: {
      message: defineMessage({
        id: 'docsShell.integrationBuilder.test-cards.terminal.one',
        defaultMessage: 'Payment succeeds',
      }),
    },
    number: '00',
  },
  {
    label: {
      message: defineMessage({
        id: 'docsShell.integrationBuilder.test-cards.terminal.two',
        defaultMessage: 'Payment is declined',
      }),
    },
    number: '01',
  },
];

export const TestCard = ({
  label,
  number,
}: {|
  label: MessageDescriptor,
  number: string,
|}) => {
  const [copied, setCopied] = React.useState(false);
  const {fireEvent, copyValue} = useGuide();

  return (
    <Box
      flex={{alignItems: 'center', justifyContent: 'space-between'}}
      margin={{bottom: 4}}
      className="testcard-row"
    >
      <Box flexGrow={1} flexBasis={0}>
        <BodyAlt>
          <FormattedMessageOrString stringOrDefineMessage={label} />
        </BodyAlt>
      </Box>
      <ButtonLink
        color="blue"
        style={{margin: 0}}
        label={
          <BodyMono color="inherit" style={{fontWeight: '600'}}>
            {number}
          </BodyMono>
        }
        icon={copied ? 'check' : 'clipboard'}
        iconPosition="right"
        onClick={(evt) => {
          evt.stopPropagation();
          fireEvent('copy_test_card', {
            number,
          });
          copyValue(number);
          setCopied(true);

          setTimeout(() => {
            setCopied(false);
          }, 1500);
        }}
      />
    </Box>
  );
};

export function DefaultCards() {
  return (
    <Box margin={{top: 8}}>
      {cards.map((c) => (
        <TestCard key={c.number} label={c.label} number={c.number} />
      ))}
    </Box>
  );
}

export function TerminalCards() {
  return (
    <Box margin={{top: 8}}>
      {terminalCards.map((c) => (
        <TestCard key={c.number} label={c.label} number={c.number} />
      ))}
    </Box>
  );
}
